import instance from 'api';
import { IPartnerRating } from '../../interfaces';

export const savePartnerRating = (partnerRatings: IPartnerRating[]) => {
  return instance()
    .post(`/realEstate/partner/rating/listSave`, partnerRatings)
    .then((response) => response.data);
};
